import { render, staticRenderFns } from "./CustomFields.vue?vue&type=template&id=7d87eabc&scoped=true"
import script from "./CustomFields.vue?vue&type=script&lang=ts"
export * from "./CustomFields.vue?vue&type=script&lang=ts"
import style0 from "./CustomFields.vue?vue&type=style&index=0&id=7d87eabc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d87eabc",
  null
  
)

export default component.exports